import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handleGetRequest } from "../../services/GetTemplate";
import * as Yup from "yup";

function DepositSubDetailForm({ SetSubDetailsData, editRowData, handleEditSubDetails }) {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [baseLocationOptions, setbaseLocationOptions] = useState([]);

    useEffect(() => {
        handleGetRequest("/zbizgateway/lov/lovBranch").then((res) => {
            setbaseLocationOptions(res?.data);
        });
    }, []);

    useEffect(() => {
        if (editRowData) {
            formik.setFieldValue("branchId", editRowData?.branchId);
            formik.setFieldValue("chequeNo", editRowData?.chequeNo);
            formik.setFieldValue("chequeDate", editRowData?.chequeDate);
            formik.setFieldValue("chequeAmount", editRowData?.chequeAmount);
        }
    }, [editRowData]);

    const validationSchema = Yup.object().shape({
        branchId: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            branchId: "",
            chequeNo: "",
            chequeAmount: "",
            chequeDate: "",
        },
        onSubmit: async (data) => {
            if (editRowData && editRowData.id) {
                data.id = editRowData.id;
                handleEditSubDetails(data);
            } else {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");
                SetSubDetailsData(data);
                setloading(false);
                setloadingIcon("pi pi-save");
                formik.resetForm();
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Deposit Sub Detail Form</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field">
                                <label htmlFor="branchId" className={classNames({ "p-error": isFormFieldValid("branchId") }, "Label__Text")}>
                                    Branch Code<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="branchId"
                                    placeholder="Select"
                                    options={baseLocationOptions}
                                    optionLabel="description"
                                    name="branchId"
                                    value={formik.values.branchId}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("branchId") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("branchId")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field">
                                <label htmlFor="chequeNo" className={classNames({ "p-error": isFormFieldValid("chequeNo") }, "Label__Text")}>
                                    Cheque No.
                                </label>
                                <InputText id="chequeNo" name="chequeNo" value={formik.values.chequeNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("chequeNo") }, "Input__Round")} />

                                {getFormErrorMessage("chequeNo")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field">
                                <label htmlFor="chequeDate" className={classNames({ "p-error": isFormFieldValid("chequeDate") }, "Label__Text")}>
                                    Cheque Date
                                </label>
                                <InputText id="chequeDate" type="date" name="chequeDate" value={formik.values.chequeDate} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("chequeDate") }, "Input__Round")} />

                                {getFormErrorMessage("chequeDate")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field">
                                <label htmlFor="chequeAmount" className={classNames({ "p-error": isFormFieldValid("chequeAmount") }, "Label__Text")}>
                                    Cheque Amount
                                </label>
                                <InputText id="chequeAmount" placeholder="50000.00" name="chequeAmount" value={formik.values.chequeAmount} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("chequeAmount") }, "Input__Round")} />

                                {getFormErrorMessage("chequeAmount")}
                            </div>
                        </div>
                    </div>
                    <div className="Down__Btn">
                        <Button disabled={loading} type="submit" icon={loadingIcon || ""} iconPos="right" label={editRowData.id ? "Edit" : "Add"} className="Btn__Dark" />
                    </div>
                </form>
            </div>
        </>
    );
}

export default DepositSubDetailForm;
